<template>
    <div>
      <b-button class=" conButton"
                variant="outline-warning"
                :class="htmlResponseC ? 'col-1 float-right':'col-12'"
                @click="vnc()">{{htmlResponseC ? 'X':'Konsole öffnen'}}
      </b-button>
      <b-container  v-if="spinner"
                    class="text-center">
        <h1 class="justify-content-center">
          <b-spinner></b-spinner>
        </h1>
      </b-container>

      <div>
        <div :class="htmlResponseC ? 'con':''"
             v-html="htmlResponseC">
        </div>
        </div>
    </div>
</template>

<script>
  import axios from "@/store/vue-axios"
    export default {
        name: "luma-console-vserver",
        data:()=>({
            spinner:false,
            htmlResponse:null
        }),
        computed:{
            htmlResponseC(){
                return this.htmlResponse
            },
            vid(){
                return this.$route.params.id
            },

        },
        methods:{
            async vnc(){
                if(!this.htmlResponse){
                    this.spinner = true
                    const x = await axios.get("/datacenter/vservers/"+this.vid+"/vnc")
                        .then(response=>{
                            this.spinner = false
                            this.htmlResponse = response.data.html//Object.assign({},response)
                        })
                        .catch(error=>{
                            console.log('VSERVER KONSOLE ERROR::::', error)
                        })
                }
                else {
                    this.htmlResponse = null
                    return
                }
            }
        }
    }
</script>

<style scoped>
  .conButton{
    z-index:1
  }

  .con{
  height: 800px;
  overflow-y: hidden;
}

</style>



// WEBPACK FOOTER //
// src/components/datacenter/vserver_datacenter/luma-console-vserver.vue